import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useIsStaff } from "@/hooks/useStaffRoles";
import { PERF_OVERLAY_EVENT } from "@/lib/perfOverlay";

/** Staff-only (perf_overlay flag) corner badge showing the current page's data load time. */
export function PerfOverlay() {
  const enabled = useFeatureFlag("perf_overlay");
  const { isStaff } = useIsStaff();
  const { pathname } = useLocation();
  const [ms, setMs] = useState<number | null>(null);

  useEffect(() => { setMs(null); }, [pathname]);
  useEffect(() => {
    const on = (e: Event) => setMs((e as CustomEvent).detail?.ms ?? null);
    window.addEventListener(PERF_OVERLAY_EVENT, on);
    return () => window.removeEventListener(PERF_OVERLAY_EVENT, on);
  }, []);

  const show = enabled && isStaff && ms !== null;
  return (
    <div
      hidden={!show}
      dir="ltr"
      className="pointer-events-none fixed bottom-2 left-2 z-[100] rounded bg-foreground/80 px-2 py-0.5 font-mono text-[11px] text-background"
    >
      {ms ?? 0} ms
    </div>
  );
}
